import React, { memo } from 'react';
// import ListSearchHeader from '../../../shared/components/ListSearchHeader/ListSeachHeader';
import LoaderButton from '../../../shared/components/LoaderButton/LoaderButton';
import styles from './userDetailHeader.module.scss';

export default memo(function UserDetailHeader(props) {
    function handleClick() {
        if (props.match.params.id) {
            props.updateUserRequest(props.match.params.id, props.history);
        } else {
            props.createUserRequest(props.history);
        }
    }

    return (
        <div className={styles.container}>
            {/* <ListSearchHeader dictionary="common" text="search_configuration" /> */}
            {   props.permissions!==null && parseInt(props.permissions[0])==11 ?
                <LoaderButton
                    dictionary="common"
                    disabled={!props.canCreate}
                    inProgress={props.isCreating}
                    onClick={handleClick}
                    text="confirm"
                /> :
                null
            }
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.canCreate === nextProps.canCreate &&
        prevProps.isCreating === nextProps.isCreating
);
